<template>
	<div class="drawing_canvas">
		<div class="drawing_option">
			<div class="item">
				<div class="op"><span :style="{background: penColor}"></span><input type="color" name="" @change="myColor"></div>
			</div>
	
<!-- 			<div class="item range-wrap">
				<input type="range" class="range" min="20" max="940" @change="range">
			
			</div> -->
			<div class="item" @click="draw" :class="active == 0 ? 'active' : ''">
				<div class="op"><img src="../assets/img/pencil.png"></div>
			</div>
			
			<div class="item" @click="clear">
				<div class="op"><img src="../assets/img/trash.png"></div>
			</div>
		</div>
		<div class="board" ref="board" :style="{border: '1px solid #000', 'background-color': backgroundColor}">
			<canvas ref="signature-pad" id="canvaQs">
		</canvas>
		
		</div>
		<div class="div">
			<button @click="result" class="btn-submit" type="submit">{{$t("txt_findOut")}}</button>
		</div>
</div>
	

</template>
<style scoped>
	.drawing_canvas {margin:5px;max-width: 80%;margin:0 auto;}
    .drawing_canvas  .drawing_option {
    	border: 1px solid #000;
    border-bottom: none;
    }
    .drawing_canvas .div {
    	text-align: center;
    	margin: 15px 0;
    }
    .drawing_canvas .div .btn-submit {
    	background-color: #3b5999;
	    border: none;
	    color: white;
	    padding: 15px 32px;
	    text-align: center;
	    text-decoration: none;
	    display: inline-block;
	    font-size: 18px;
	    width: 80%;
	    border-radius: 5px;
	    text-transform: capitalize;
	  	cursor: pointer;
    }
    .drawing_canvas .div .btn-submit:hover {
    	background-color: #314e8d
    }
	.drawing_canvas .drawing_option {display: flex;}
	.drawing_canvas .drawing_option .item {
		display: flex;
  		padding: 5px;
    	flex-grow: 1;
	    align-items: center;
	    justify-content: center;
	    position: relative;
	    background: #d8d8d8;
    border-left: 1px solid #fff;
	}
	.drawing_canvas .drawing_option .item.range-wrap input {
		width: 80px;
	}
	.drawing_canvas .drawing_option .item span {
		width: 30px;
	    height: 30px;
	    display: block;
	    border-radius: 3px;
	}
	.drawing_canvas .drawing_option .item input[type="color"] {
		position: absolute;
	    top: 0;
	    left: 0;
	    opacity: 0;
	    width: 100%;
	    height: 100%;
	}

	.drawing_canvas .drawing_option .item .op {
		width: 40px;height: 40px;
		box-shadow: 0 0 1px 1px rgb(0 0 0 / 50%);
    	border-radius: 4px;
    	padding:5px;
    	transition: all .5s;
    	position: relative;
	}


	.drawing_canvas .drawing_option .item.active .op {background: #fae33e}
	.drawing_canvas .drawing_option .item .op img {width: 100%;height: 100%;}
</style>
<script>
import SignaturePad from "signature_pad"
export default {
    name: "drawing",
    data: function() {
        return {
	        canvas: null,
	        ctx: null,
	        signaturePad: null,
	        size: 1,
	        color: "#000",
	        active: 0
        }
    },
    props: {
    	backgroundColor: {
    		type: String,
    		default: "rgb(255,255,255)"
    	},
    	penColor: {
    		type: String,
    		default: "#000"
    	}
    },
    mounted: function() {
    	this.canvas = this.$refs["signature-pad"]
    	this.ctx = this.canvas.getContext('2d');
    	this.resizeCanvas()
    	this.init()
    },
    methods: {
    	range(e){
    		console.log(e.target.value)
    	},
    	myColor(e){
    		this.penColor = e.target.value;
    		this.signaturePad.penColor = e.target.value;
    	},
		resizeCanvas() {
		    this.canvas.width = this.$refs["board"].clientWidth;
		    this.canvas.height = this.$refs["board"].clientWidth; //clientHeight
		    // this.canvas.getContext("2d").scale(ratio, ratio);
		},
		init(){
			this.signaturePad = new SignaturePad(this.canvas, {
			  	backgroundColor: "rgba(255, 255, 255, 0)",
			  	penColor: this.penColor
			});
		},
		clear(){
			this.signaturePad.clear();
		},
		draw(){
			try{
		  		this.ctx.globalCompositeOperation = 'source-over'; // default value
			}catch(err){
				console.log(err)
			}
			
		},
		changeColor(){
			var r = Math.round(Math.random() * 255);
			var g = Math.round(Math.random() * 255);
			var b = Math.round(Math.random() * 255);
			var color = "rgb(" + r + "," + g + "," + b +")";

			this.signaturePad.penColor = color;
		},
		erase(){
			this.ctx.globalCompositeOperation = 'destination-out';
		},
		changeSize(){
			this.ctx.lineWidth = 50
		},
		result(){
			var data = this.signaturePad.toDataURL()
			this.$store.state.base64Draw = data
			this.$emit("onResult", data)
		}
    }
}

</script>